import { render, staticRenderFns } from "./CostSettings.vue?vue&type=template&id=06cb4ec6&scoped=true&"
import script from "./CostSettings.vue?vue&type=script&lang=js&"
export * from "./CostSettings.vue?vue&type=script&lang=js&"
import style0 from "./CostSettings.vue?vue&type=style&index=0&id=06cb4ec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cb4ec6",
  null
  
)

export default component.exports